import { render, staticRenderFns } from "./AddResourceModal.vue?vue&type=template&id=33c7a494&lang=pug"
import script from "./AddResourceModal.vue?vue&type=script&lang=js"
export * from "./AddResourceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports